<ion-app>
  <p-toast styleClass="mt-12 max-w-[85vw]" />
  <p-confirmdialog />
  <ion-router-outlet></ion-router-outlet>
</ion-app>